(function () {
  'use strict';

  var JSPDF_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function QuoteModal(productId) {
    this.productId = productId;
    this.modal = document.getElementById('quote-modal-' + productId);
    if (!this.modal) return;

    this.form = document.getElementById('quote-form-' + productId);
    this.qtyInput = document.getElementById('quote-qty-' + productId);
    this.priceEl = document.getElementById('quote-price-' + productId);
    this.subtotalEl = document.getElementById('quote-subtotal-' + productId);
    this.successEl = document.getElementById('quote-success-' + productId);
    this.hiddenBody = document.getElementById('quote-body-' + productId);
    this.optionsContainer = document.getElementById('quote-options-' + productId);

    this.currentPrice = parseInt(this.qtyInput.dataset.price, 10) || 0;
    this._bindEvents();
  }

  QuoteModal.prototype._bindEvents = function () {
    var self = this;

    // Quantity buttons
    this.modal.querySelectorAll('[data-qty-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(self.qtyInput.value, 10) || 1;
        self.qtyInput.value = btn.dataset.qtyAction === 'increase' ? v + 1 : Math.max(1, v - 1);
        self._updateSubtotal();
      });
    });
    this.qtyInput.addEventListener('input', function () { self._updateSubtotal(); });

    // Form submit
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self._submitForm();
    });

    // PDF button
    var pdfBtn = this.modal.querySelector('[data-quote-pdf]');
    if (pdfBtn) pdfBtn.addEventListener('click', function () { self._generatePDF(); });

    // Close buttons
    this.modal.querySelectorAll('[data-quote-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });

    // Close on backdrop click
    this.modal.addEventListener('click', function (e) {
      if (e.target === self.modal) self.close();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal.classList.contains('is-open')) self.close();
    });

    // Variant change — works with standard select and custom events
    var variantSelect = document.querySelector(
      'select[name="id"], variant-selects, variant-radios'
    );
    if (variantSelect) {
      variantSelect.addEventListener('change', function () { self._syncVariantFromPage(); });
    }
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) self._applyVariant(e.detail.variant);
    });
  };

  QuoteModal.prototype._updateSubtotal = function () {
    var qty = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
    this.qtyInput.value = qty;
    if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(this.currentPrice * qty);
  };

  QuoteModal.prototype._syncVariantFromPage = function () {
    var idInput = document.querySelector('.product-variant-id');
    if (!idInput) return;
    var variantId = idInput.value;
    var dataEl = document.getElementById('quote-variants-' + this.productId);
    if (!dataEl) return;
    try {
      var variants = JSON.parse(dataEl.textContent);
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (variant) this._applyVariant(variant);
    } catch (e) {}
  };

  QuoteModal.prototype._applyVariant = function (variant) {
    this.currentPrice = variant.price;
    if (this.priceEl) {
      this.priceEl.textContent = formatMoney(variant.price);
      this.priceEl.dataset.price = variant.price;
    }
    if (this.optionsContainer && variant.options) {
      this.optionsContainer.querySelectorAll('[data-option-index]').forEach(function (el) {
        var idx = parseInt(el.dataset.optionIndex, 10);
        if (variant.options[idx] !== undefined) el.textContent = variant.options[idx];
      });
    }
    this._updateSubtotal();
  };

  QuoteModal.prototype._buildBody = function () {
    var f = this.form;
    var get = function (id) {
      var el = document.getElementById(id);
      return el ? el.value.trim() : '';
    };
    var pid = this.productId;
    var productName = (this.modal.querySelector('.quote-product-name') || {}).textContent || '';
    var qty = this.qtyInput.value;
    var subtotal = formatMoney(this.currentPrice * parseInt(qty, 10));

    var optionsText = '';
    if (this.optionsContainer) {
      this.optionsContainer.querySelectorAll('.quote-option-row').forEach(function (row) {
        var label = (row.querySelector('.quote-option-label') || {}).textContent || '';
        var value = (row.querySelector('.quote-option-value') || {}).textContent || '';
        optionsText += label + ' ' + value + '\n';
      });
    }

    return [
      'QUOTE REQUEST — ' + productName.trim(),
      '',
      'PRODUCT DETAILS',
      'Product: ' + productName.trim(),
      optionsText.trim(),
      'Quantity: ' + qty,
      'Unit Price: ' + formatMoney(this.currentPrice),
      'Subtotal: ' + subtotal,
      '',
      'CUSTOMER INFORMATION',
      'Name: ' + get('quote-fname-' + pid) + ' ' + get('quote-lname-' + pid),
      'Company: ' + (get('quote-company-' + pid) || 'N/A'),
      'Email: ' + get('quote-email-' + pid),
      'Phone: ' + get('quote-phone-' + pid),
      'State/Province: ' + get('quote-state-' + pid),
      'Country: ' + get('quote-country-' + pid),
      '',
      'MESSAGE',
      get('quote-message-' + pid),
      '',
      '---',
      'Submitted via STEC Equipment website quote form.',
    ].join('\n');
  };

  QuoteModal.prototype._submitForm = function () {
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    var self = this;
    var submitBtn = this.form.querySelector('[data-quote-submit]');
    var btnText = submitBtn && submitBtn.querySelector('.quote-btn-text');
    var btnLoad = submitBtn && submitBtn.querySelector('.quote-btn-loading');

    if (submitBtn) submitBtn.disabled = true;
    if (btnText) btnText.hidden = true;
    if (btnLoad) btnLoad.hidden = false;

    this.hiddenBody.value = this._buildBody();

    var formData = new FormData(this.form);

    fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams(formData).toString(),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        self.form.hidden = true;
        self.successEl.hidden = false;
      })
      .catch(function () {
        alert(
          'There was a problem submitting your request. Please call us at 864-225-3666 or email sales@stecequipment.com'
        );
        if (submitBtn) submitBtn.disabled = false;
        if (btnText) btnText.hidden = false;
        if (btnLoad) btnLoad.hidden = true;
      });
  };

  QuoteModal.prototype._loadJsPDF = function () {
    return new Promise(function (resolve, reject) {
      if (window.jspdf) { resolve(); return; }
      var s = document.createElement('script');
      s.src = JSPDF_CDN;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  };

  QuoteModal.prototype._generatePDF = function () {
    var self = this;
    this._loadJsPDF().then(function () {
      var jsPDF = window.jspdf.jsPDF;
      var doc = new jsPDF({ unit: 'mm', format: 'a4' });
      var pid = self.productId;

      var W = 210, ML = 18, MR = 192;
      var orange = [216, 90, 48];
      var blue = [25, 118, 210];
      var darkBlue = [21, 101, 192];
      var dark = [30, 30, 30];
      var mid = [110, 110, 110];
      var light = [246, 247, 249];

      function get(id) {
        var el = document.getElementById(id + '-' + pid);
        return el ? el.value.trim() : '';
      }

      var productName = (self.modal.querySelector('.quote-product-name') || {}).textContent || 'Product';
      productName = productName.trim();
      var qty = parseInt(self.qtyInput.value, 10) || 1;
      var unitPrice = self.currentPrice;
      var subtotal = unitPrice * qty;

      // ── Header bar ──────────────────────────────────────────────────────────
      doc.setFillColor.apply(doc, orange);
      doc.rect(0, 0, W, 38, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(20);
      doc.text('STEC Equipment, Inc.', ML, 16);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text('Quote Request', ML, 25);
      doc.text('864-225-3666  |  sales@stecequipment.com', MR, 25, { align: 'right' });

      var date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
      doc.text('Date: ' + date, MR, 33, { align: 'right' });

      var y = 50;

      // ── Product Summary Section ──────────────────────────────────────────────
      doc.setFillColor.apply(doc, blue);
      doc.rect(ML, y - 6, MR - ML, 10, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('PRODUCT SUMMARY', ML + 3, y);
      y += 13;

      doc.setTextColor.apply(doc, dark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text(productName, ML, y);
      y += 8;

      // Options
      doc.setFontSize(9);
      if (self.optionsContainer) {
        self.optionsContainer.querySelectorAll('.quote-option-row').forEach(function (row) {
          var label = (row.querySelector('.quote-option-label') || {}).textContent || '';
          var value = (row.querySelector('.quote-option-value') || {}).textContent || '';
          doc.setFont('helvetica', 'bold');
          doc.setTextColor.apply(doc, mid);
          doc.text(label, ML, y);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor.apply(doc, dark);
          doc.text(value.trim(), ML + 38, y);
          y += 6;
        });
      }
      y += 4;

      // Price table
      doc.setFillColor.apply(doc, light);
      doc.rect(ML, y - 4, MR - ML, 32, 'F');

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor.apply(doc, mid);
      doc.text('Unit Price', ML + 4, y + 3);
      doc.setTextColor.apply(doc, dark);
      doc.text(formatMoney(unitPrice), MR - 4, y + 3, { align: 'right' });

      doc.setTextColor.apply(doc, mid);
      doc.text('Quantity', ML + 4, y + 12);
      doc.setTextColor.apply(doc, dark);
      doc.text(String(qty), MR - 4, y + 12, { align: 'right' });

      doc.setFillColor(230, 232, 236);
      doc.rect(ML, y + 16, MR - ML, 0.4, 'F');

      doc.setFont('helvetica', 'bold');
      doc.setTextColor.apply(doc, darkBlue);
      doc.text('Subtotal', ML + 4, y + 24);
      doc.setTextColor.apply(doc, orange);
      doc.setFontSize(12);
      doc.text(formatMoney(subtotal), MR - 4, y + 24, { align: 'right' });
      y += 44;

      // ── Customer Information ─────────────────────────────────────────────────
      doc.setFillColor.apply(doc, blue);
      doc.rect(ML, y - 6, MR - ML, 10, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('CUSTOMER INFORMATION', ML + 3, y);
      y += 13;

      var fields = [
        ['Name', get('quote-fname') + ' ' + get('quote-lname')],
        ['Company', get('quote-company') || 'N/A'],
        ['Email', get('quote-email')],
        ['Phone', get('quote-phone')],
        ['State / Province', get('quote-state')],
        ['Country', get('quote-country')],
      ];

      doc.setFontSize(9);
      fields.forEach(function (pair, i) {
        if (i % 2 === 0) {
          doc.setFillColor.apply(doc, light);
          doc.rect(ML, y - 4, MR - ML, 8, 'F');
        }
        doc.setFont('helvetica', 'bold');
        doc.setTextColor.apply(doc, mid);
        doc.text(pair[0], ML + 3, y);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor.apply(doc, dark);
        doc.text(pair[1] || '', ML + 48, y);
        y += 9;
      });
      y += 6;

      // ── Message ──────────────────────────────────────────────────────────────
      var msg = get('quote-message');
      if (msg) {
        doc.setFillColor.apply(doc, blue);
        doc.rect(ML, y - 6, MR - ML, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('MESSAGE / CUSTOMIZATIONS', ML + 3, y);
        y += 13;

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor.apply(doc, dark);
        var lines = doc.splitTextToSize(msg, MR - ML - 6);
        doc.text(lines, ML + 3, y);
        y += lines.length * 5.5 + 8;
      }

      // ── Footer ───────────────────────────────────────────────────────────────
      doc.setFillColor.apply(doc, light);
      doc.rect(0, 278, W, 20, 'F');
      doc.setFillColor.apply(doc, orange);
      doc.rect(0, 278, W, 1.5, 'F');
      doc.setTextColor.apply(doc, mid);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text(
        'STEC Equipment, Inc.  |  864-225-3666  |  (888) 325-2532 (toll-free)  |  sales@stecequipment.com  |  stecequipment.com',
        W / 2, 288, { align: 'center' }
      );
      doc.text('Quote request generated ' + date, W / 2, 294, { align: 'center' });

      var safeName = productName.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').substring(0, 40);
      doc.save('STEC-Quote-' + safeName + '.pdf');
    }).catch(function () {
      alert('PDF generation failed. Please try again or contact us directly.');
    });
  };

  QuoteModal.prototype.open = function () {
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.add('is-open');
    document.body.classList.add('quote-modal-open');
    var first = this.modal.querySelector('input[required], select[required], textarea[required]');
    if (first) setTimeout(function () { first.focus(); }, 120);
  };

  QuoteModal.prototype.close = function () {
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.classList.remove('is-open');
    document.body.classList.remove('quote-modal-open');
  };

  // ── Bootstrap ────────────────────────────────────────────────────────────────
  var instances = {};

  function init() {
    document.querySelectorAll('[data-quote-open]').forEach(function (btn) {
      var id = btn.dataset.quoteOpen;
      btn.addEventListener('click', function () {
        if (!instances[id]) instances[id] = new QuoteModal(id);
        instances[id].open();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
